import { SERVER_URL } from "./config";

const groupNames = ["group-1"];

function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

let challanReportDataObject = {
  total_amount: "",
  total_pkgs: "",
  total_weight: "",
  total_rows: "",
};

let challanReportGroupInfo = {
  "group-1": [
    {
      label: "Total Memo",
      className: "form-row-m",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "total_memo",
      type: "text",
      placeHolder: "1234",
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
    {
      label: "Total Pkgs",
      className: "form-row-m",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "total_pkgs",
      type: "text",
      placeHolder: "1234",
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
    {
      label: "Total Weight",
      className: "form-row-m",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "total_weight",
      type: "text",
      placeHolder: "1234",
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
  ],
};

if (["bgtc", "ase"].includes(process.env.REACT_APP_CLIENT)) {
  challanReportDataObject = {
    total_amount: "",
    total_pkgs: "",
    total_weight: "",
    total_rows: "",
    total_to_pay: "",
    total_paid: "",
    total_to_be_billed: "",
  };

  challanReportGroupInfo = {
    "group-1": [
      {
        label: "Total Memo",
        className: "form-row-m",
        labelClassName: "form-label-w-bgtc",
        inputClassName: "form-input-bgtc",
        name: "total_memo",
        type: "text",
        placeHolder: "1234",
      },
      {
        label: "Total Pkgs",
        className: "form-row-m",
        labelClassName: "form-label-w-bgtc",
        inputClassName: "form-input-bgtc",
        name: "total_pkgs",
        type: "text",
        placeHolder: "1234",
      },
      {
        label: "Total Weight",
        className: "form-row-m",
        labelClassName: "form-label-w-bgtc",
        inputClassName: "form-input-bgtc",
        name: "total_weight",
        type: "text",
        placeHolder: "1234",
      },

      {
        label: "Total To Pay",
        className: "form-row-m",
        labelClassName: "form-label-w-bgtc",
        inputClassName: "form-input-bgtc",
        name: "total_to_pay",
        type: "text",
        placeHolder: "1234",
      },
      {
        label: "Total Paid",
        className: "form-row-m",
        labelClassName: "form-label-w-bgtc",
        inputClassName: "form-input-bgtc",
        name: "total_paid",
        type: "text",
        placeHolder: "1234",
      },
      {
        label: "Total TBB",
        className: "form-row-m",
        labelClassName: "form-label-w-bgtc",
        inputClassName: "form-input-bgtc",
        name: "total_to_be_billed",
        type: "text",
        placeHolder: "1234",
      },
    ],
  };
}

export { groupNames, challanReportGroupInfo, challanReportDataObject };
